import React,{useState,useEffect} from 'react'
import {Container,Form,Col} from "react-bootstrap"
import Title from "../../../utilities/other/title"
function UnclassifiedParkinsonism(props){
    const handler = (event) =>{
        props.handler("unclassified_parkinsonism",event)
    }
    return(
        <>
            <Title>{props.title}</Title>
            <Form>
                <Form.Row>
                    <Form.Group as={Col}>
                        <Form.Label>Unclassified Parkinsonism</Form.Label>
                        <Form.Control as={"select"} onChange={handler} name={"unclassified_parkinsonism"} value={props.data!=null?props.data['unclassified_parkinsonism']:null} disabled={props.edit}>
                            <option></option>
                            <option>Yes</option>
                            <option>No</option>

                        </Form.Control>
                    </Form.Group>
                   
                </Form.Row>
            </Form>
        </>
    )
}
UnclassifiedParkinsonism.defaultProps={
    data:null
}

export default UnclassifiedParkinsonism